module.exports = __webpack_public_path__ + "img/8fe328b94cadd9c117b588e64f35e666.png";


//////////////////
// WEBPACK FOOTER
// ./src/scripts/lib/images/finance_logo18.png
// module id = 926
// module chunks = 5